import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unsaved-confiurations-modal',
  templateUrl: './unsaved-confiurations-modal.component.html',
  styleUrls: ['./unsaved-confiurations-modal.component.scss'],
})
export class UnsavedConfigurationsModalComponent {
  public selectedOption: string;

  constructor(
    public dialogRef: MatDialogRef<UnsavedConfigurationsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public dataService: DataService,
    public accessService: AccessService
  ) {}

  discardChanges() {
    this.dialogRef.close('discard');
  }

  keepChanges() {
    this.dialogRef.close('stay');
  }
}
